import { CalendarCardProps } from "./types";
import { StyledCard, StyledImg } from "./styles";
import { Box, Typography, useTheme } from "@mui/material";

const  CalendarCard: React.FC<CalendarCardProps> = ({data, handleClick}) => {
    const theme = useTheme();

    const handleCardClick = (id: number) => {
        if(handleClick) handleClick(id);
    };

    return(
        <StyledCard theme={theme} onClick={() => handleCardClick(data.id)}>
            <Box p={1} style={{overflow: "hidden", maxWidth:"270px", maxHeight:"257px", borderRadius:"10px" }}>
                <StyledImg src={data.image} alt={data.title} width="auto" style={{maxWidth:'100%'}} height="auto"/>
            </Box>
            <Box>
                <Typography variant="h6" style={{maxWidth: "250px", whiteSpace:"break-spaces", margin:"15px 10px"}} >
                    {data.title}
                </Typography>
                <Typography variant="subtitle1" color="textDisabled" 
                style={{textOverflow: "ellipsis", maxWidth: "342px", overflow: "hidden", whiteSpace: "nowrap", margin:"15px 10px"}}>
                    {data.subtitle}
                </Typography>
            </Box>
        </StyledCard> 
    )
}

export default CalendarCard;